// extracted by mini-css-extract-plugin
export default {"card":"Error_card__n2UvQ","container":"Error_container__4-6UU","errorTitle":"Error_errorTitle__4ZIdY","errorMessage":"Error_errorMessage__BPRNP"};